// Vendor imports
import { Fancybox } from "@fancyapps/ui"
import Alpine from "alpinejs"
import collapse from "@alpinejs/collapse"
import focus from "@alpinejs/focus"
import intersect from "@alpinejs/intersect"
import breakpoint from "alpinejs-breakpoints"
Alpine.plugin(intersect)
Alpine.plugin(breakpoint)
Alpine.plugin(collapse)
Alpine.plugin(focus)
window.Alpine = Alpine

// Booking
Alpine.data('bookingCalendar', () => {
	const today = new Date()
	const tomorrow = new Date(today)
	tomorrow.setDate(today.getDate() + 1)
	const fmt = (y, m, d) => y + '-' + String(m + 1).padStart(2, '0') + '-' + String(d).padStart(2, '0')

	return {
	adults: 2,
	children: 0,
	checkInDate: fmt(tomorrow.getFullYear(), tomorrow.getMonth(), tomorrow.getDate()),
	checkOutDate: null,
	inMonth: tomorrow.getMonth(),
	inYear: tomorrow.getFullYear(),
	outMonth: tomorrow.getMonth(),
	outYear: tomorrow.getFullYear(),
	dayNames: ['Mo','Tu','We','Th','Fr','Sa','Su'],
	daysInMonth(m, y) { return new Date(y, m + 1, 0).getDate(); },
	firstDay(m, y) { let d = new Date(y, m, 1).getDay(); return d === 0 ? 6 : d - 1; },
	grid(m, y) {
		let cells = [], fd = this.firstDay(m, y), dim = this.daysInMonth(m, y);
		let pm = m === 0 ? 11 : m - 1, py = m === 0 ? y - 1 : y;
		let nm = m === 11 ? 0 : m + 1, ny = m === 11 ? y + 1 : y;
		let dpm = this.daysInMonth(pm, py);
		for (let i = fd - 1; i >= 0; i--) cells.push({ day: dpm - i, month: pm, year: py, other: true });
		for (let i = 1; i <= dim; i++) cells.push({ day: i, month: m, year: y, other: false });
		let rem = 42 - cells.length;
		for (let i = 1; i <= rem; i++) cells.push({ day: i, month: nm, year: ny, other: true });
		return cells;
	},
	fmt(y, m, d) { return y + '-' + String(m + 1).padStart(2, '0') + '-' + String(d).padStart(2, '0'); },
	isPast(m, y, d) { let t = new Date(); t.setHours(0,0,0,0); return new Date(y, m, d) < t; },
	isIn(c) { return !c.other && this.checkInDate === this.fmt(c.year, c.month, c.day); },
	isOut(c) { return !c.other && this.checkOutDate === this.fmt(c.year, c.month, c.day); },
	inRange(c) {
		if (!this.checkInDate || !this.checkOutDate || c.other) return false;
		let cur = this.fmt(c.year, c.month, c.day);
		return cur > this.checkInDate && cur < this.checkOutDate;
	},
	selectIn(c) {
		if (c.other || this.isPast(c.month, c.year, c.day)) return;
		this.checkInDate = this.fmt(c.year, c.month, c.day);
		if (this.checkOutDate && this.checkOutDate <= this.checkInDate) this.checkOutDate = null;
	},
	selectOut(c) {
		if (c.other || this.isPast(c.month, c.year, c.day)) return;
		let date = this.fmt(c.year, c.month, c.day);
		if (this.checkInDate && date <= this.checkInDate) return;
		this.checkOutDate = date;
	},
	prevIn() { if (this.inMonth===0){this.inMonth=11;this.inYear--;}else this.inMonth--; },
	nextIn() { if (this.inMonth===11){this.inMonth=0;this.inYear++;}else this.inMonth++; },
	prevOut() { if (this.outMonth===0){this.outMonth=11;this.outYear--;}else this.outMonth--; },
	nextOut() { if (this.outMonth===11){this.outMonth=0;this.outYear++;}else this.outMonth++; },
	submit() {
		if (!this.checkInDate || !this.checkOutDate) return;
		window.open(
			'https://book-directonline.com/properties/hotelpanorama'
			+ '?check_in_date=' + this.checkInDate
			+ '&check_out_date=' + this.checkOutDate
			+ '&number_adults=' + this.adults
			+ '&number_children=' + this.children,
			'_blank'
		);
	},
	}
})

// Popup start
document.addEventListener('alpine:init', () => {
	Alpine.data('popupModal', () => ({
	show: false,

	init() {
		if (!this.getCookie('popupShown')) {
		setTimeout(() => {
			this.show = true;
		}, 700);
		}
	},

	// Set cookie with expiry
	setCookie(name, value, days) {
		let expires = "";
		if (days) {
		const date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		expires = "; expires=" + date.toUTCString();
		}
		document.cookie = name + "=" + (value || "") + expires + "; path=/";
	},

	// Get cookie
	getCookie(name) {
		const nameEQ = name + "=";
		const ca = document.cookie.split(';');
		for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === ' ') c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
		}
		return null;
	},

	close() {
		this.show = false;
		
		// Set cookie for 7 days (change as needed)
		this.setCookie('popupShown', 'true', 7);
	}
	}));
});

window.AlpineBreakpointPluginBreakpointsList = [
	"xs",
	"sm",
	"md",
	"lg",
	"xl",
	"2xl",
	"3xl",
]
window.Alpine.start()

import "lazysizes/plugins/respimg/ls.respimg"
import "lazysizes/plugins/parent-fit/ls.parent-fit"
import "lazysizes"
import "lazysizes/plugins/object-fit/ls.object-fit"

// Module imports
import "./modules/eye"
import "./modules/svgIconSprite"
import "./modules/fancyapps"
import "./modules/gsap"
import "./modules/carousel"
import "./modules/filters"
import initContactaButton from "./modules/contactaButton"

// Initialize Contacta button animation
initContactaButton()
